import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "../01_core/auth/auth.service";
import { ManufacturingOrderModel } from "../07_feature/manufacturing-order/manufacturing-order.model";
import { environment } from "../../environments/environment";
import { firstValueFrom } from "rxjs";

const tenantID = 'tebisInternalTenant';

@Injectable({ providedIn: 'root' })
export class ManufacturingOrderRepository {

  http = inject(HttpClient);
  authService = inject(AuthService);
  authorizedHttp = this.authService.authorize(this.http);

  getOrdersByIDs(ids: string[]) {
    const queryParams = [`tenantID=${tenantID}`];
    const requests = ids.map(id => {
      return firstValueFrom(this.authorizedHttp.get<ManufacturingOrderModel>(`${environment.baseUrl}/order/${id}?${queryParams.join('&')}`));
    });
    return Promise.all(requests);
  }
}
